import styled from 'styled-components';

const ProfileName = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textPrimary || '#333'};
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    font-size: ${({ theme }) => theme.fontSizes.small || '0.9rem'};
  }
`;

export default ProfileName;
